/** @format */

import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import { useAuth } from "../Contexts/useAuth";
import { useNavigate } from "react-router-dom";
import Paper from "@mui/material/Paper";
import MenuList from "@mui/material/MenuList";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import PreviewIcon from "@mui/icons-material/Preview";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";

export default function Dashboard() {
  const navigate = useNavigate();
  const { isAdmin } = useAuth();

  return (
    <>
      <Alert
        severity="success"
        color="success"
        sx={{ my: 2 }}
        iconMapping={{
          success: <FormatListBulletedIcon fontSize="inherit" />,
        }}
      >
        <Typography component="h1" variant="h6">
          Menu Dashboard
        </Typography>
      </Alert>
      <Box sx={{ bgcolor: "background.paper", width: 700 }}>
        <Paper sx={{ width: "100%", maxWidth: "100%" }} elevation={3}>
          {isAdmin ? (
            <MenuList>
              <MenuItem
                onClick={() => {
                  navigate("/vendors");
                }}
              >
                <ListItemIcon>
                  <FormatListBulletedIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>List of Vendors</ListItemText>
              </MenuItem>

              <MenuItem
                onClick={() => {
                  navigate("/all-products");
                }}
              >
                <ListItemIcon>
                  <FormatListBulletedIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>List of Products</ListItemText>
              </MenuItem>

              <MenuItem onClick={() => navigate("/all-shipments")}>
                <ListItemIcon>
                  <PreviewIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>
                  List of Shipment And Payment Details
                </ListItemText>
              </MenuItem>
              <MenuItem
                onClick={() =>
                  navigate("/add-to-product-category-and-subcategory")
                }
              >
                <ListItemIcon>
                  <PlaylistAddIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>
                  Add Product Category And Sub Category
                </ListItemText>
              </MenuItem>
              <MenuItem onClick={() => navigate("/add-customer")}>
                <ListItemIcon>
                  <PersonAddAlt1Icon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Add Customer</ListItemText>
              </MenuItem>
              <MenuItem onClick={() => navigate("/unlock")}>
                <ListItemIcon>
                  <LockOpenIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Unlock vendor profile/Shipment</ListItemText>
              </MenuItem>
              <MenuItem
                onClick={() => navigate("/download-dispatch-clearence-report")}
              >
                <ListItemIcon>
                  <CloudDownloadIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Download Dispatch Clearance Report</ListItemText>
              </MenuItem>
            </MenuList>
          ) : (
            <MenuList>
              <MenuItem
                onClick={() => {
                  navigate("/add-product");
                }}
              >
                <ListItemIcon>
                  <PlaylistAddIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Add New Product</ListItemText>
              </MenuItem>
              <MenuItem
                onClick={() => {
                  navigate("/products");
                }}
              >
                <ListItemIcon>
                  <FormatListBulletedIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>View Product List</ListItemText>
              </MenuItem>
              <MenuItem onClick={() => navigate("/add-shipment")}>
                <ListItemIcon>
                  <PlaylistAddIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Add New Shipment Details</ListItemText>
              </MenuItem>
              <MenuItem onClick={() => navigate("/shipment-and-payment-list")}>
                <ListItemIcon>
                  <PreviewIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>
                  View/Edit Shipment And Payment Details
                </ListItemText>
              </MenuItem>
            </MenuList>
          )}
        </Paper>
      </Box>
    </>
  );
}
